import { render, staticRenderFns } from "./ConfirmBulkAction.vue?vue&type=template&id=5031fb48&scoped=true&"
import script from "./ConfirmBulkAction.vue?vue&type=script&lang=js&"
export * from "./ConfirmBulkAction.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBulkAction.vue?vue&type=style&index=0&id=5031fb48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031fb48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5031fb48')) {
      api.createRecord('5031fb48', component.options)
    } else {
      api.reload('5031fb48', component.options)
    }
    module.hot.accept("./ConfirmBulkAction.vue?vue&type=template&id=5031fb48&scoped=true&", function () {
      api.rerender('5031fb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Jobs/components/wizard/ConfirmBulkAction.vue"
export default component.exports